export default __webpack_public_path__ + "static/media/mon_64.161bdd67.png";